/* Mobify Audio theme JS — original code */
(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Slider component (with optional autoplay) ---------- */
  class SliderComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider]');
      if (!this.track) return;
      this.prevBtn = this.querySelector('[data-slide-prev]');
      this.nextBtn = this.querySelector('[data-slide-next]');
      this.dots = Array.from(this.querySelectorAll('[data-slide-to]'));
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.scrollBySlide(-1); this.restartAutoplay(); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.scrollBySlide(1); this.restartAutoplay(); });
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const slides = this.slides();
          const i = parseInt(dot.dataset.slideTo, 10);
          if (slides[i]) this.track.scrollTo({ left: slides[i].offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
          this.restartAutoplay();
        });
      });
      this.track.addEventListener('scroll', () => this.updateDots(), { passive: true });

      /* autoplay */
      this.autoplayMs = parseInt(this.dataset.autoplay || '0', 10);
      if (this.autoplayMs > 0 && !REDUCED_MOTION) {
        this.startAutoplay();
        ['pointerenter', 'touchstart', 'focusin'].forEach((ev) =>
          this.addEventListener(ev, () => this.stopAutoplay(), { passive: true }));
        ['pointerleave', 'focusout'].forEach((ev) =>
          this.addEventListener(ev, () => this.startAutoplay()));
        document.addEventListener('visibilitychange', () => {
          document.hidden ? this.stopAutoplay() : this.startAutoplay();
        });
      }
    }
    disconnectedCallback() { this.stopAutoplay(); }
    startAutoplay() {
      if (!this.autoplayMs || this.timer) return;
      this.timer = setInterval(() => this.advance(), this.autoplayMs);
    }
    stopAutoplay() { clearInterval(this.timer); this.timer = null; }
    restartAutoplay() { if (this.autoplayMs) { this.stopAutoplay(); this.startAutoplay(); } }
    advance() {
      const t = this.track;
      if (t.scrollLeft + t.clientWidth >= t.scrollWidth - 10) {
        t.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        this.scrollBySlide(1);
      }
    }
    slides() { return Array.from(this.track.children).filter((el) => el.classList.contains('slider__slide')); }
    slideWidth() {
      const s = this.slides();
      return s.length > 1 ? s[1].offsetLeft - s[0].offsetLeft : this.track.clientWidth;
    }
    scrollBySlide(dir) { this.track.scrollBy({ left: dir * this.slideWidth(), behavior: 'smooth' }); }
    updateDots() {
      if (!this.dots.length) return;
      const i = Math.round(this.track.scrollLeft / this.slideWidth());
      this.dots.forEach((d, idx) => d.classList.toggle('is-active', idx === i));
    }
  }
  if (!customElements.get('slider-component')) customElements.define('slider-component', SliderComponent);

  /* ---------- Quantity input ---------- */
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      const input = this.querySelector('input');
      const minus = this.querySelector('[data-qty-minus]');
      const plus = this.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', () => { input.value = Math.max(parseInt(input.min || 0, 10), (parseInt(input.value, 10) || 1) - 1); input.dispatchEvent(new Event('change', { bubbles: true })); });
      if (plus) plus.addEventListener('click', () => { input.value = (parseInt(input.value, 10) || 0) + 1; input.dispatchEvent(new Event('change', { bubbles: true })); });
    }
  }
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);

  /* ---------- Product gallery: thumbnails + prev/next ---------- */
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.slides = Array.from(this.querySelectorAll('[data-media]'));
      this.prevBtn = this.querySelector('[data-gallery-prev]');
      this.nextBtn = this.querySelector('[data-gallery-next]');
      this.current = 0;
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.show(parseInt(thumb.dataset.thumb, 10)));
      });
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.show(this.current - 1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.show(this.current + 1));
    }
    show(i) {
      if (!this.slides.length) return;
      this.current = (i + this.slides.length) % this.slides.length;
      this.slides.forEach((s) => s.classList.toggle('is-active', parseInt(s.dataset.media, 10) === this.current));
      this.thumbs.forEach((t) => t.classList.toggle('is-active', parseInt(t.dataset.thumb, 10) === this.current));
    }
  }
  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);

  /* ---------- Product form: AJAX add + variant selection ---------- */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
      this.variantJson = this.querySelector('[data-variant-json]');
      this.selects = Array.from(this.querySelectorAll('[data-option-select]'));
      this.selects.forEach((s) => s.addEventListener('change', () => this.onOptionChange()));

      /* Color swatches drive their hidden <select> */
      this.querySelectorAll('[data-swatch-group]').forEach((group) => {
        const groupIndex = parseInt(group.dataset.swatchGroup, 10);
        const select = this.selects[groupIndex];
        const swatches = Array.from(group.querySelectorAll('[data-swatch-value]'));
        swatches.forEach((swatch) => {
          swatch.addEventListener('click', () => {
            if (select) {
              select.value = swatch.dataset.swatchValue;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
            swatches.forEach((s) => s.classList.toggle('is-active', s === swatch));
          });
        });
      });
    }
    onOptionChange() {
      if (!this.variantJson) return;
      const variants = JSON.parse(this.variantJson.textContent);
      const chosen = this.selects.map((s) => s.value);
      const match = variants.find((v) => chosen.every((val, i) => v.options[i] === val));
      const idInput = this.querySelector('[data-variant-id]');
      const addBtn = this.querySelector('[data-add-button]');
      const addLabel = this.querySelector('[data-add-label]');
      if (match) {
        idInput.value = match.id;
        if (addBtn) addBtn.disabled = !match.available;
        if (addLabel) addLabel.textContent = match.available ? 'Add to cart' : 'Sold out';
      } else {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
      }
    }
    async onSubmit(e) {
      e.preventDefault();
      const btn = this.form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      try {
        const res = await fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: new FormData(this.form) });
        if (!res.ok) throw new Error('Add to cart failed');
        await updateCartCount();
        flashButton(btn, 'Added!');
      } catch (err) {
        flashButton(btn, 'Error — try again');
      } finally {
        if (btn) btn.disabled = false;
      }
    }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  /* ---------- Bundle: add all to cart ---------- */
  class BundleForm extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('[data-bundle-add]');
      if (!btn) return;
      btn.addEventListener('click', async () => {
        const ids = Array.from(this.querySelectorAll('[data-bundle-variant]'))
          .map((el) => parseInt(el.dataset.bundleVariant, 10)).filter(Boolean);
        if (!ids.length) return;
        btn.disabled = true;
        try {
          const res = await fetch(window.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })) })
          });
          if (!res.ok) throw new Error('failed');
          await updateCartCount();
          flashButton(btn, 'Added to cart!');
        } catch (err) {
          flashButton(btn, 'Could not add — check stock');
        } finally {
          btn.disabled = false;
        }
      });
    }
  }
  if (!customElements.get('bundle-form')) customElements.define('bundle-form', BundleForm);

  /* ---------- Info tabs: auto-rotate + progress + synced image ---------- */
  class InfoTabs extends HTMLElement {
    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[data-tab-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
      this.list = this.querySelector('[data-tab-list]');
      this.current = 0;
      this.triggers.forEach((t) => t.addEventListener('click', () => {
        this.activate(parseInt(t.dataset.tabTrigger, 10));
        this.restart();
      }));
      this.autoplayMs = parseInt(this.dataset.autoplay || '0', 10);
      if (this.autoplayMs > 0 && !REDUCED_MOTION) {
        this.start();
        document.addEventListener('visibilitychange', () => {
          document.hidden ? this.stop() : this.start();
        });
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => entry.isIntersecting ? this.start() : this.stop());
        }, { threshold: 0.2 });
        observer.observe(this);
      }
      this.activate(0);
    }
    disconnectedCallback() { this.stop(); }
    start() { if (this.autoplayMs && !this.timer) this.timer = setInterval(() => this.activate((this.current + 1) % this.triggers.length), this.autoplayMs); }
    stop() { clearInterval(this.timer); this.timer = null; }
    restart() { if (this.autoplayMs) { this.stop(); this.start(); } }
    activate(i) {
      this.current = i;
      this.triggers.forEach((t) => {
        const item = t.closest('.info-tabs__item');
        const on = parseInt(t.dataset.tabTrigger, 10) === i;
        if (on) {
          /* restart the underline progress animation */
          item.classList.remove('is-active');
          void item.offsetWidth;
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
        t.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      this.panels.forEach((p) => p.classList.toggle('is-active', parseInt(p.dataset.tabPanel, 10) === i));
      /* keep active title in view on mobile horizontal list */
      if (this.list && window.innerWidth < 750) {
        const active = this.triggers[i] && this.triggers[i].closest('.info-tabs__item');
        if (active) this.list.scrollTo({ left: active.offsetLeft - this.list.offsetLeft - 16, behavior: 'smooth' });
      }
    }
  }
  if (!customElements.get('info-tabs')) customElements.define('info-tabs', InfoTabs);

  /* ---------- Helpers ---------- */
  async function updateCartCount() {
    try {
      const res = await fetch(window.routes.cart_url + '.js');
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
    } catch (e) { /* noop */ }
  }
  function flashButton(btn, text) {
    if (!btn) return;
    const label = btn.querySelector('span') || btn;
    const original = label.textContent;
    label.textContent = text;
    setTimeout(() => { label.textContent = original; }, 1800);
  }

  /* ---------- Image banner slideshow (data-slideshow) ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (slideshow) {
    var track = slideshow.querySelector('[data-slideshow-track]');
    if (!track) return;
    var slides = Array.from(track.children);
    var dots = Array.from(slideshow.querySelectorAll('[data-slideshow-dot]'));
    var prevBtn = slideshow.querySelector('[data-slideshow-prev]');
    var nextBtn = slideshow.querySelector('[data-slideshow-next]');
    var index = 0;
    var timer = null;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
    }
    track.style.transition = 'transform 0.5s ease';
    if (dots.length) dots[0].classList.add('is-active');

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); restart(); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goTo(i); restart(); }); });

    var autoplaySeconds = parseFloat(slideshow.getAttribute('data-autoplay'));
    function start() {
      if (!autoplaySeconds || slides.length < 2 || REDUCED_MOTION) return;
      timer = setInterval(function () { goTo(index + 1); }, autoplaySeconds * 1000);
    }
    function stop() { clearInterval(timer); timer = null; }
    function restart() { if (autoplaySeconds) { stop(); start(); } }
    start();
    ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) {
      slideshow.addEventListener(ev, stop, { passive: true });
    });
    ['pointerleave', 'focusout'].forEach(function (ev) {
      slideshow.addEventListener(ev, start);
    });
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });
  });

  /* ---------- Mobile menu ---------- */
  document.addEventListener('click', (e) => {
    const drawer = document.querySelector('[data-menu-drawer]');
    if (!drawer) return;
    if (e.target.closest('[data-menu-toggle]')) drawer.classList.add('is-open');
    if (e.target.closest('[data-menu-close]')) drawer.classList.remove('is-open');
  });
})();
